module.exports = __webpack_public_path__ + "static/media/chelseaONeal.95e6cb80.jpg";